import request from 'services/axios'

export const getTransactions = async ({
    cursor,
    q,
    date,
}: IDashboardTransactionsParams) => {
    const { data }: { data: IDashboardTransactions } = await request.get(
        '/api/v1/payment/transactions/',
        {
            params: {
                cursor,
                ...(q ? { q } : {}),
                ...(date ? { date } : {}),
            },
        }
    )
    return data
}
